export default "__VITE_ASSET__y2N$x1ss__"